import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgSettingsRateCard({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path d="M10.9 7.85L6.25 3.3c-.2-.2-.47-.3-.74-.3H1.05C.47 3 0 3.46 0 4.03v4.39c0 .27.11.53.3.73l4.64 4.55c.41.4 1.08.4 1.49 0l4.46-4.39c.41-.4.41-1.05 0-1.46zM2.44 6.44c-.58 0-1.05-.46-1.05-1.03 0-.57.47-1.04 1.05-1.04.58 0 1.05.47 1.05 1.04 0 .57-.47 1.03-1.05 1.03zM13.69 9.3l-4.46 4.4c-.41.4-1.08.4-1.49 0v-.01l3.8-3.74a1.9 1.9 0 000-2.73L7.24 3h1.08c.27 0 .54.1.74.3l4.63 4.55c.41.4.41 1.06 0 1.46z" />
    </svg>
  );
}

SvgSettingsRateCard.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgSettingsRateCard.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgSettingsRateCard svgRef={ref} {...props} />
));
export default ForwardRef;
